import React from 'react';
import { Marker } from 'react-map-gl';
import { colors } from '../../modules/theme';
export default function LocatioMarker({ location }) {
  if (!location) return null;
  return (
    <Marker
      css={{ zIndex: 10 }}
      latitude={location.value[1]}
      longitude={location.value[0]}
    >
      <img
        style={{
          transform: 'translate(-50%,-100%)',
          color: colors.orange,
        }}
        alt="location pin"
        src={process.env.URL + '/place.svg'}
      />
    </Marker>
  );
}
